import React, { useState } from 'react'
import { useRouter } from 'next/router'
import Icon from 'components/elements/Icon'

import Link from 'components/elements/Link'
import LabelDisplay from 'components/collectionV2/misc/LabelDisplay'
import EditLabelsModal from 'components/collectionV2/forms/EditLabelsModal'

import { useAppSelector } from 'redux/hooks'

import styles from './labels.module.scss'

type Props = {}

const LabelsView = ({}: Props) => {
  const router = useRouter()

  const tags = useAppSelector(state => state.collectionV2.tags)

  const [editLabelsMenuOpen, setEditLabelsMenuOpen] = useState(false)

  const username = `${router.query.username}`
  const tagsArray = Object.values(tags).sort((a, b) => a.name.localeCompare(b.name))

  return (
    <div className={styles.container}>
      <div className={styles.controls}>
        <h2>Collection labels</h2>
        <button onClick={() => setEditLabelsMenuOpen(true)}>
          <Icon name="tags" />
          Create / edit collection labels
        </button>
      </div>

      <div className={styles.table}>
        {tagsArray.map((tag, key) => (
          <Link href={`/collection/v2/${username}/?andTags=${tag.id}`} className={styles.row} key={key}>
            <LabelDisplay name={tag.name} color={tag.color} />

            <span>
              <Icon name="arrow right" />
              View cards
            </span>
          </Link>
        ))}
      </div>

      <EditLabelsModal open={editLabelsMenuOpen} onClose={() => setEditLabelsMenuOpen(false)} />
    </div>
  )
}
export default LabelsView
